import { css } from 'styled-components';
import { semantic, neutral, secondary } from '../../../theme/colors';
import { hex2rgba } from '../../../theme/interpolateColors';
import shadows from '../../../theme/shadows';
import typography from '../../../theme/typography';
export const PrimaryDark = {
    colors: {
        main: '#00B2E3',
        mainDark: '#0087C1',
        mainLight: '#7EE3FF',
        ...semantic,
        ...neutral,
        ...secondary,
        //
        black_1: '#D3DFEB',
        black_2: '#00B2E3',
        black_3: '#131E29',
        //
        blackDark_1: '#ADB9C4',
        blackDark_2: '#0087C1',
        blackDark_3: '#071420',
        //
        grey00_1: '#2C2D31',
        grey00_2: '#FFFFFF',
        grey00_3: '#2C2D31',
        grey00_4: '#FFFFFF',
        grey00_5: '#ADB9C4',
        grey00_6: '#27282C',
        grey00_7: '#232325',
        //
        grey01_1: '#282A2D',
        grey01_2: '#4B4C55',
        grey01_3: '#37383D',
        //
        grey05_1: '#232325',
        grey05_2: '#45495D',
        grey05_3: '#37383D',
        grey05_4: '#37383D',
        //
        grey10_1: '#32343E',
        grey10_2: '#37383D',
        grey10_3: '#343745',
        grey10_4: '#37383D',
        grey10_5: '#45495E',
        grey10_6: '#272727',
        //
        grey30_1: '#3F4455',
        grey30_2: '#37383D',
        grey30_3: '#37383D',
        //
        grey70_1: '#88939F',
        grey70_2: '#37383D',
        grey70_3: '#6D7E89',
        //
        grey100_1: '#9EA8B2',
        grey100_2: '#6D7E89',
        //
        positive120_1: '#056B42',
        positive120_2: '#004227',
        //
        positive30_1: '#74E6AD',
        positive30_2: '#E8FCF1',
        //
        positive10_1: '#E8FCF1',
        positive10_2: '#74E6AD',
        //
        warning120_1: '#A57412',
        warning120_2: '#614000',
        //
        warning30_1: '#FDDC72',
        warning30_2: '#FFF2CC',
        //
        warning10_1: '#FFF2CC',
        warning10_2: '#FDDC72',
        //
        critical120_1: '#BB2532',
        critical120_2: '#700009',
        //
        critical30_1: '#FF8993',
        critical30_2: '#FFD1DA',
        //
        critical10_1: '#FFD1DA',
        critical10_2: '#FF8993',
        critical10_3: '#37383D',
        //
        link120_1: '#1257EA',
        link120_2: '#042F60',
        //
        link100: '#6495FF',
        //
        link70: '#85ACFF',
        //
        link30_1: '#CCDCFF',
        link30_2: '#B1CFFB',
        //
        link10_1: '#ECF2FF',
        link10_2: '#4C8AF6',
    },
    shadows: {
        ...shadows,
        focus: css `
      box-shadow: 0 0 0 3px ${({ theme }) => hex2rgba(theme.colors.main, 0.35)};
    `,
        error: css `
      box-shadow: 0 0 0 3px ${({ theme }) => hex2rgba(theme.colors.critical100, 0.25)};
    `,
        warning: css `
      box-shadow: 0 0 0 3px ${({ theme }) => hex2rgba(theme.colors.warning100, 0.2)};
    `,
        success: css `
      box-shadow: 0 0 0 3px ${({ theme }) => hex2rgba(theme.colors.positive100, 0.2)};
    `,
        large: css `
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
        medium: css `
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
        small: css `
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.grey10_1};
    `,
    },
    typography,
    borders: {
        radiusMedium: 8,
    },
    themeId: 'primaryDark',
};
